import styled from 'styled-components';
import { heading3, spacing } from 'ui/theme';

export const ReadOnlyExperimentName = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  ${heading3};
  line-height: 2.2rem; /** work-around because text descenders are being clipped by overflow hidden */
  border-bottom: ${spacing.single} dashed transparent;
`;
